/* globals localStorage */
// const OktaAuth = require("@okta/okta-auth-js");
// const authClient = new OktaAuth({
//   url: process.env.VUE_APP_OKTA_SERVER,
//   issuer: process.env.VUE_APP_OKTA_ISSUER,
//   clientId: process.env.VUE_APP_CLIENTID,
//   redirectUri: process.env.VUE_APP_BASE_URL+'/callback'
// });

import { msalInstance } from 'vue-msal-browser'

import Callback from '@/components/Callback'

const loginRequest = {scopes:process.env.VUE_APP_MSAL_SCOPES.split(',')}
let idToken = null;
let accessToken = null;

export default {
    
  login(){
    msalInstance.loginRedirect(loginRequest)
  },

  getName() {
    const claims = this.parseJwt(localStorage.idToken);
    return claims["name"];
  },
  getLoginRequest(){
    return loginRequest;
  },

  async getUser() {
    let token = await this.getAccessToken();
    if (!token) {
      token = localStorage.idToken;
    }

    const user = this.parseJwt(token);
    return user;
  },


//   async isLabUser() {
//     const token = await this.getAccessToken();
//     const claims = this.parseJwt(token);
//     if('eaRole' in claims) {
//       return claims['eaRole'][0] === 'LabUser';    
//     }
//     return false;
//   },

//   async getTenants() {
//     const token = await this.getAccessToken();
//     const claims = this.parseJwt(token);
//     if('eaTenants' in claims) {
//       return claims['eaTenants'];    
//     }
//   },

  parseJwt(token) {
    if (!token || typeof token !== "string") {
      console.warn("parseJwt called with invalid token", token);
      return {};
    }

    const parts = token.split(".");
    if (parts.length < 2) {
      console.warn("parseJwt received malformed token", token);
      return {};
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    try {
      return JSON.parse(window.atob(base64));
    } catch (err) {
      console.warn("parseJwt failed to decode token", err);
      return {};
    }
  },
    
  logout(){
      msalInstance.logoutRedirect(loginRequest)
  },

  setAccessToken(token){
    accessToken = token
  },

   async isLoggedIn() {
     const token = await this.getAccessToken();
      if (token == null || token == "" ||token == "undefined") {
        return false;
      }
      return true;
  },

//   printRefresh() {
//     if (
//       localStorage.token == null ||
//       localStorage.token == "" ||
//       localStorage.token == "undefined"
//     )
//       return false;
//   },

  getAccessToken(){
    return accessToken;
  },

  handleCallback () { return Callback },

  getFromUri () {
    const path = localStorage.getItem('referrerPath') || '/'
    localStorage.removeItem('referrerPath')
    return path
  },

  async handleAuthentication () {
    const tokens = await authClient.token.parseFromUrl()
    tokens.forEach(token => {
      if (token.accessToken) authClient.tokenManager.add('accessToken', token)
      if (token.idToken) authClient.tokenManager.add('idToken', token)
    })
  }
};
